import React, { useEffect, useState } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import RatingBreakdown from "../components/RatingBreakdown";
import "./ProductDetailsPage.css";
import api from "../components/api";
import ReviewItem from "../components/ReviewItem";
import WishListBtn from "../components/WishListBtn";
import RateProduct from "../components/RateProduct";
import PostModel from "../components/PostModel";
import { FollowProvider } from "../context/FollowContext";

export default function ReviewPage() {
  const [isPostModelOpen, setIsPostModelOpen] = useState(false);
  const [preSelectedCategory, setPreSelectedCategory] =
    useState("Ask the community");
  const [preSelectedProduct, setPreSelectedProduct] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [currentValue, setCurrentValue] = useState(
    location.state?.currentValue || 0
  );
  const [isRatingSubmitted, setIsRatingSubmitted] = useState(
    location.state?.isRatingSubmitted || false
  );
  const [productDetails, setProductDetails] = useState(
    location.state?.productDetails || null
  );

  // Fetch product details only if not passed from ProductDetailsPage
  const fetchProductDetails = async (id) => {
    try {
      const response = await api.get(`/products/${id}`);
      const productDetails = response.data;
      setProductDetails(productDetails);
      return productDetails;
    } catch (error) {
      console.log(error);
    }
  };

  // Fetch user profile data
  const fetchUserProfile = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await api.get("/profile", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUserProfile(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching user profile:", error);
      setUserProfile(null);
      return null;
    }
  };

  const handleProfileClick = (user) => {
    if (!user || !user.id) return;
    navigate(`/profile/${user.id}`, { state: { user } });
  };

  useEffect(() => {
    fetchUserProfile();
    if (!productDetails) {
      fetchProductDetails(location.state?.productDetails?.id);
    }
    // eslint-disable-next-line   react-hooks/exhaustive-deps
  }, [productDetails]);

  const handleSubmit = () => {
    setIsRatingSubmitted(true);
    if (productDetails) {
      fetchProductDetails(productDetails.id); // Refresh product details after review submission
    }
  };

  if (!productDetails) {
    return <div>Error: No product details available.</div>;
  }

  return (
    <>
      <div className="container">
        <FollowProvider>
          <div className="row w-100">
            <div className="col-12 col-md-6 d-flex flex-column">
              {/* product-image */}
              <div className="product-image mt-5 position-relative overflow-hidden">
                <Link to={`/product-details/${productDetails.id}`}>
                  <img
                    src={
                      productDetails.image
                        ? productDetails.image
                        : "https://placehold.co/260x360/FFF/c2c2c2?text=No+Picture"
                    }
                    alt={productDetails.name}
                    className="img-fluid rounded mt-3 object-fit-cover"
                  />
                </Link>
                <span className="wishlist-wrapper">
                  <WishListBtn
                    isAdd={productDetails.wishlist}
                    productId={productDetails.id}
                    onSuccess={() => fetchProductDetails(productDetails.id)}
                  />
                </span>
                <span
                  className="ask-community-wrapper"
                  onClick={() => {
                    setPreSelectedCategory("Ask the community");
                    setPreSelectedProduct(productDetails);
                    setIsPostModelOpen(true);
                  }}
                >
                  Ask community about this product
                </span>
              </div>
            </div>

            <div className="col-12 col-md-6 el d-flex flex-column">
              {/* Ratings */}
              <div className="ratings mt-5">
                <h5 className="section-title">Ratings</h5>
                <div className="row">
                  <div className="rating-summary col-lg-6 col-12 mb-4 mb-lg-0">
                    <h2 className="average-rating d-flex align-items-center">
                      <strong>{productDetails.rate}</strong>
                      <span className="text-muted">
                        <strong>/5 </strong>
                      </span>
                      <img
                        src={`/images/icons/Full star.svg`}
                        alt="rating star"
                        className="ms-2"
                      />
                    </h2>
                    <p className="rating-users">
                      {productDetails.rate_count} users rated
                    </p>
                    <RatingBreakdown
                      rateDetail={productDetails.rate_detail}
                      rateCount={productDetails.rate_count}
                    />
                  </div>

                  <RateProduct
                    productDetails={productDetails}
                    currentValue={currentValue}
                    setCurrentValue={setCurrentValue}
                    onRatingSubmit={handleSubmit}
                    isRatingSubmitted={isRatingSubmitted}
                    setIsRatingSubmitted={setIsRatingSubmitted}
                  />
                </div>
              </div>

              <div className="reviews module5 mt-5 mb-3">
                <h5 className="section-title">Reviews</h5>
                {productDetails.product_reviews.map((review) => (
                  <ReviewItem
                    key={review.id}
                    review={review}
                    onProfileClick={handleProfileClick}
                  />
                ))}
              </div>
            </div>
          </div>
        </FollowProvider>
      </div>
      {isPostModelOpen && (
        <PostModel
          profile={userProfile}
          isOpen={isPostModelOpen}
          onClose={() => setIsPostModelOpen(false)}
          preSelectedCategory={preSelectedCategory}
          preSelectedProduct={preSelectedProduct}
        />
      )}
    </>
  );
}
